var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { JobCommentSectionSkeleton } from './job-comment-skeleton';
export var JobCommentSkeletonList = function (_a) {
    var _b = _a.count, count = _b === void 0 ? 3 : _b;
    return (_jsx("div", { className: 'space-y-4', children: __spreadArray([], Array(count), true).map(function (_, index) { return (_jsx(JobCommentSectionSkeleton, {}, index)); }) }));
};
